import { StyledSpinner } from './styles';
import { StyledSpinnerProps } from './types';

export const Loader = (props?: StyledSpinnerProps) => {
  return <StyledSpinner {...props} />;
};
